module.exports = __webpack_public_path__ + "static/media/comparison_bar.669dfe36.png";


//////////////////
// WEBPACK FOOTER
// ./src/comparison_bar.png
// module id = 192
// module chunks = 0